module.exports = __webpack_public_path__ + "3c69b54740b20693ba19732a06f91a7d.svg";